import { runAramPostRuntimeRegression } from '../../application/aramPostRuntimeRegression.js';

/**
 * wireAramRegressionHook — Expose P4-01 checklist for agent CDP smoke.
 */
export function wireAramRegressionHook() {
  if (typeof window === 'undefined') return null;
  window.__debugAramRegression = () => runAramPostRuntimeRegression();
  return window.__debugAramRegression;
}
